import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<BrowserRouter data-id="element-337" data-mp="218mnpazf5t3p">
      <App data-id="element-338" data-mp="21cadbz1qtvd5" />
    </BrowserRouter>);
}